var React = require('react');

function ChevronDownGreen (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"Header/Mobile---Signed-In","transform":"translate(-253, -28)","stroke":"#12DFC7","strokeWidth":"2"},React.createElement("g",{"id":"Group-5","transform":"translate(136, 11)"},React.createElement("g",{"id":"Search-Copy-3","transform":"translate(44, 9)"},React.createElement("polyline",{"id":"Path","points":"82 9 78 13 74 9"})))))]);
}

ChevronDownGreen.defaultProps = {"width":"10px","height":"6px","viewBox":"0 0 10 6","version":"1.1"};

module.exports = ChevronDownGreen;

ChevronDownGreen.default = ChevronDownGreen;
